import gql from 'graphql-tag'

export const SALE_PRODUCTS = gql`
  query SalesProducts(
    $search: String
    $page: Int!
    $pageSize: Int!
    $units: [ID]
    $sort: [String]
    $sort_direction: [SortDirection]
    $app: Boolean
    $app_units: [ID]
    $activatable: Boolean
    $has_image: Boolean
    $omit_sales: [ID!]
    $franchise: Boolean
    $only_franchise: Boolean
    $status: [SalesProductStatusEnum]
  ) {
    salesProducts(
      search: $search
      page: $page
      pageSize: $pageSize
      units: $units
      sort: $sort
      sort_direction: $sort_direction
      app: $app
      app_units: $app_units
      activatable: $activatable
      has_image: $has_image
      omit_sales: $omit_sales
      franchise: $franchise
      only_franchise: $only_franchise
      status: $status
    ) {
      records
      page
      salesProducts {
        _id
        sku
        name
        ean
        eans
        image_url
        isEditable
        categories_final_consumer {
          department {
            _id
            name
            image
          }
          category {
            _id
            name
            image
            department_id
          }
          sub_category {
            _id
            name
            image
            category_id
          }
        }
        type
        personalized
        activatable
        products {
          name
          sku
        }
        units {
          id_erp
          name
        }
        app_units {
          id_erp
          name
        }
        additional_points_rate
        cashback_absolute
        discount_percentage
        cashback_percentage
        percentage_discount
        take
        pay
        price
        discounted_price
        target_products {
          percentage_discount
          ean
          eans
          name
          sku
        }
        start_date
        end_date
        created_by_industry
        rules_exhibition
      }
    }
  }
`

export const SORTABLE_SALE_PRODUCTS = gql`
  query SalesProducts(
    $search: String
    $page: Int!
    $pageSize: Int!
    $units: [ID]
    $sort: [String]
    $sort_direction: [SortDirection]
    $app: Boolean
    $app_units: [ID]
    $activatable: Boolean
    $omit_sales: [ID!]
    $active: Boolean
    $target_audience: SaleTargetAudience
    $has_image: Boolean
    $franchise: Boolean
    $only_franchise: Boolean
    $grouped_sales_discount: Boolean
  ) {
    salesProducts(
      search: $search
      page: $page
      pageSize: $pageSize
      units: $units
      sort: $sort
      sort_direction: $sort_direction
      app: $app
      app_units: $app_units
      activatable: $activatable
      omit_sales: $omit_sales
      active: $active
      target_audience: $target_audience
      has_image: $has_image
      franchise: $franchise
      only_franchise: $only_franchise
      grouped_sales_discount: $grouped_sales_discount
    ) {
      records
      page
      salesProducts {
        _id
        sku
        name
        image_url
        type
        personalized
        price
        additional_points_rate
        discounted_price
        discount_percentage
        cashback_percentage
        cashback_absolute
        percentage_discount
        take
        pay
        price
        discounted_price
        target_products {
          percentage_discount
          ean
          eans
          name
          sku
        }
        start_date
        end_date
      }
    }
  }
`

export const HIGHLIGHTED_SALE_PRODUCTS = gql`
  query HighlightedSalesProducts($app_units: [ID!]!, $activatable: Boolean, $page: Int, $pageSize: Int, $franchise: Boolean, $search: String) {
    highlightedSalesProducts(app_units: $app_units, activatable: $activatable, page: $page, pageSize: $pageSize, franchise: $franchise, search: $search) {
      records
      page
      highlightedSalesProducts {
        _id
        sku
        name
        image_url
        additional_points_rate
        cashback_absolute
        price
        discounted_price
        discount_percentage
        cashback_percentage
        type
        personalized
        start_date
        end_date
        percentage_discount
        take
        pay
        price
        discounted_price
        target_products {
          percentage_discount
          ean
          eans
          name
          sku
        }
      }
    }
  }
`

export const AGGREGATED_SALES_INFO = gql`
  query AggregatedSalesInfo {
    aggregatedSalesInfo {
      sales_count
      sales_with_image_count
      activatable_sales_count
      personalized_sales_count
    }
  }
`

export const UPDATE_SALE_APP_UNITS = gql`
  mutation SetSaleProductAppUnits($_id: ID!, $units: [ID]!) {
    setSaleProductAppUnits(_id: $_id, units: $units)
  }
`

export const UPDATE_FRANCHISE_SALE_APP_UNITS = gql`
  mutation SetFranchiseSaleProductAppUnits($_id: ID!, $units: [ID]!) {
    setFranchiseSaleProductAppUnits(_id: $_id, units: $units)
  }
`

export const SET_HIGHLIGHT_SALES = gql`
  mutation SetSalesHighlightPositions($sales_ids: [ID!]!, $app_units: [ID!]!, $activatable: Boolean!) {
    setSalesHighlightPositions(sales_ids: $sales_ids, app_units: $app_units, activatable: $activatable)
  }
`

export const MUTATION_UPDATE_GROUP_APP_SALES = gql`
  mutation UpdateGroupAppSale($data: InputUpdateGroupAppSale!) {
    updateGroupAppSale(data: $data)
  }
`

export const GET_PRODUCT = gql`
  query FindProduct($filter: FilterFindProductInput) {
    findProduct(filter: $filter) {
      id
      legacySku
      images {
        isMain
        order
        url
        urlMiniature
        urlThumbnail
      }
      categoryId
      departmentId
      subcategoryId
      name
      measure {
        acronym
        active
        fractionalSale
        name
      }
    }
  }
`
